import React from "react";
var __jsx = React.createElement;
import { SvgIcon } from "@mui/material";
export default function CommentIcon() {
  return /*#__PURE__*/React.createElement(SvgIcon, {
    viewBox: "0 0 106 128",
    height: "24",
    width: "20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 69c0 7.16-5.83 13-13 13H57.56L39 99.87V82H24c-7.17 0-13-5.84-13-13V43c0-7.17 5.83-13 13-13h58c7.17 0 13 5.83 13 13v26zM82 20H24C11.32 20 1 30.31 1 43v26c0 12.68 10.32 23 23 23h5v19c0 2 1.2 3.81 3.04 4.6.63.27 1.3.4 1.96.4 1.27 0 2.52-.49 3.47-1.4L61.59 92H82c12.68 0 23-10.32 23-23V43c0-12.69-10.32-23-23-23"
  }));
}
CommentIcon.defaultProps = {
  fontSize: "inherit"
};